module.exports = __webpack_public_path__ + "img/midia-festival-logo-2025-black.97412c1f.png";